import { NotificationCycleValues } from './NotificationCycleModal/types';

export const NOTIFY_TIME_VALUES: NotificationCycleValues = {
  notifyTypeId: null,
  timeZoneId: null,
  isSentMonday: null,
  isSentTuesday: null,
  isSentWednesday: null,
  isSentThursday: null,
  isSentFriday: null,
  isSentSaturday: null,
  isSentSunday: null,
  startSendTime: null,
  endSendTime: null,
  lastRun: null,
  _rowTimestamp: null,
};
